"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReviewCommentInput = exports.MAX_FEEDBACK_COMMENT_LENGTH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = require("react");
exports.MAX_FEEDBACK_COMMENT_LENGTH = 500;
/**
 * Componente para coletar feedback textual do usuário no momento da avaliação da compra
 *
 * @param {OrderReviewCommentInputProps} ContainerProps - Propriedades passadas para a div que envolve o componente
 * @param {OrderReviewCommentInputProps} disabled - Indica se o campo de input e o botão devem ser desabilitados
 * @param {OrderReviewCommentInputProps} isLoading - Indica se o componente está carregando / aguardando resolução de uma requisição
 * @param {OrderReviewCommentInputProps} onSubmit - A função a ser chamada após clicar em "Enviar avaliação"
 * @return {JSX.Element}
 */
const OrderReviewCommentInput = ({ ContainerProps, disabled, isLoading, onSubmit, }) => {
    const [comment, setComment] = (0, react_1.useState)('');
    const handleChangeComment = (event) => {
        var _a;
        setComment((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    const handleSubmit = () => {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(comment);
    };
    const isDisabled = disabled || isLoading;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, ContainerProps, { children: [(0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ direction: "column", align: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Input, { value: comment, disabled: isDisabled, "aria-disabled": isDisabled, onChange: handleChangeComment, maxLength: exports.MAX_FEEDBACK_COMMENT_LENGTH, id: "comment", name: "comment", labelText: "Conte como foi sua experi\u00EAncia (opcional).", as: "textarea", css: {
                            height: '116px',
                        } }), (0, jsx_runtime_1.jsxs)(flora_react_1.Text, Object.assign({ size: "auxiliarMini", color: comment.length === exports.MAX_FEEDBACK_COMMENT_LENGTH
                            ? '$error-standard'
                            : '$nonInteractivePredominant' }, { children: [comment.length, " / ", exports.MAX_FEEDBACK_COMMENT_LENGTH] }))] })), (0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ isFull: true, variant: "standard", "autotagging-flora": "on", "aria-label": isLoading ? 'Enviando avaliação' : 'Enviar avaliação', "data-flora-section": "avaliacao_compra", "data-flora": "click", "data-flora-text": `Enviar avaliação de compra ${comment ? 'com comentário' : 'sem comentário'}`, isLoading: isLoading, disabled: isDisabled, onClick: handleSubmit, "aria-disabled": isDisabled, css: { marginTop: '$10' } }, { children: "Enviar avalia\u00E7\u00E3o" }))] })));
};
exports.OrderReviewCommentInput = OrderReviewCommentInput;
exports.OrderReviewCommentInput.defaultProps = {
    disabled: false,
    isLoading: false,
};
